import cn from 'classnames';
import { useMemo } from 'react';

import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { parseDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';

import styles from './KnmActGeneral.module.scss';
import { DatePicker } from '../../../UIPackage/MainModule/components/DatePicker';
import { convertInitialKnmDateToFormDate } from '../../MainModule/common/convertInitialKnmDateToFormDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';

interface IErknmActsItemProps {
  isDecision?: boolean;
  isDisabledField: boolean;
  isKnm?: boolean;
  isPm?: boolean;
  name: string;
  prefixId: string;
  signActDateTime?: string;
  startDate?: string;
  extractVersion?: number;
  decisionMinHoldingDateTime?: string;
}

export const KnmActGeneral = ({
  name,
  isPm,
  isKnm,
  isDisabledField,
  prefixId,
  isDecision,
  startDate,
  extractVersion,
  signActDateTime,
  decisionMinHoldingDateTime,
}: IErknmActsItemProps) => {
  const signDate = useMemo(() => {
    if (!signActDateTime) {
      return '';
    }

    return convertInitialKnmDateToFormDate(signActDateTime, DATE_FORMAT_LONG_MINUTE_FNS, DATE_FORMAT_ISO_FNS);
  }, [signActDateTime]);

  const parseStartDate = parseDate({
    date: startDate || new Date() || '',
    parseFormat: DATE_FORMAT_LONG_FNS,
  });

  const parseDecisionMinHoldingDateTime = parseDate({
    date: decisionMinHoldingDateTime || '',
    parseFormat: DATE_FORMAT_LONG_FNS,
  });

  return (
    <div className={styles.Wrapper}>
      <FieldBlock label={'Основные сведения об акте'} />
      <Row>
        <FieldBlock
          label={`Дата и время подписания акта${isDecision ? ' КНМ, СР' : ''}`}
          color="black"
          placementLabel="left"
          type="not-space"
          id={`${prefixId}.signActDateTime`}
          className={cn(styles.DateAndTimeCreation, styles.FieldBlock)}
        >
          <DatePicker name={`${name}.signActDateTime`} value={signDate} disabled={true} timeFormat postfix="(МСК)" />
        </FieldBlock>
      </Row>
      {extractVersion && extractVersion > 1 && (
        <Row>
          <FieldBlock
            label={`Дата и время подписания первой версии акта${isDecision ? ' КНМ, СР' : ''}`}
            color="black"
            placementLabel="left"
            type="not-space"
            id={`${prefixId}.firstExtractDateTime`}
            className={cn(styles.DateAndTimeCreation, styles.FieldBlock)}
          >
            <DatePickerField name={`${name}.firstExtractDateTime`} disabled={true} timeFormat postfix="(МСК)" />
          </FieldBlock>
        </Row>
      )}
      <Row>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: `Дата и время начала проведения${isDecision ? ' КНМ, СР' : ''}`,
            field: `${name}.holdingDateTime`,
            isPm,
            isKnm,
            isDecision,
          })}
          color="black"
          placementLabel="left"
          type="not-space"
          id={`${prefixId}.holdingDateTime`}
          className={styles.FieldBlock}
        >
          <DatePickerField
            name={`${name}.holdingDateTime`}
            disabled={isDisabledField}
            timeFormat
            minDate={isDecision ? parseDecisionMinHoldingDateTime : parseStartDate}
          />
        </FieldBlock>
      </Row>
      <div className={styles.TermRow}>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: 'Срок проведения (в днях)',
            field: `${name}.durationDays`,
            isPm,
            isKnm,
            isDecision,
          })}
          size="half"
          color="black"
          placementLabel="left"
          id={`${prefixId}.durationDays`}
        >
          <TextInputField
            name={`${name}.durationDays`}
            disabled={isDisabledField}
            className={styles.Field}
            autoComplete="off"
          />
        </FieldBlock>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: 'Срок проведения (в часах)',
            field: `${name}.durationHours`,
            isPm,
            isKnm,
            isDecision,
          })}
          size="half"
          color="black"
          placementLabel="left"
          id={`${prefixId}.durationHours`}
        >
          <TextInputField
            name={`${name}.durationHours`}
            disabled={isDisabledField}
            className={styles.Field}
            autoComplete="off"
          />
        </FieldBlock>
      </div>
    </div>
  );
};
